import { Avatar, CardActions, CardContent, CardHeader } from '@material-ui/core';
import { Grid, TextField, MenuItem, Switch, FormControlLabel, Icon, Tooltip, FormControl, FormHelperText, IconButton } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Collapse from '@material-ui/core/Collapse';
import { Group } from '@material-ui/icons';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import CustomMaskedInput from 'components/MaskedInput/index';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { loadCustomerByEmail } from 'store/Orbita/Customer/actions';
import Truncate from 'v2/components/Shared/TruncateText';
import { run } from 'validations/ruleRunner';

import styles from '../../../styles';
import Validations from '../CoProducerForm/validations';
import { ApprobationStatus, PartnerStatus } from '../Status';

import type ICoProducer from 'interfaces/ICoProducer';
import type IUser from 'interfaces/IUser';
import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  coproducer: ICoProducer;
  onChangeRequiredFields: Function;
  onSearchSuccess: Function;
  customer: any;
  index: number;
  disabled?: boolean;
  isProducer: boolean;
  onChangeField: Function;
  onRemove: Function;
  currentUser: IUser;
  pendingStatus?: string;
  coproducers: Array<ICoProducer>;
  classes?: any;
}

interface IStates {
  validationErrors: any;
  customer: any;
  isValidEmail: boolean;
  isDeleting: boolean;
  existUser: any;
  showErrors: boolean;
  permissions: boolean;
}

const PROJECT_ELEVAR_ID = 75879698;

class PartnerCardPreview extends Component<IProps, IStates> {
  constructor(props: any) {
    super(props);
    this.state = {
      customer: {},
      isValidEmail: true,
      isDeleting: false,
      existUser: '',
      showErrors: false,
      validationErrors: {},
      permissions: false,
      //validationErrors: run(props.coproducer, fieldValidations)
    };
  }

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  onTooglePermissions = () => {
    this.setState({ permissions: !this.state.permissions });
  };

  showMoreElevar = () => {
    const ref = window.open('https://www.projetoelevar.org.br/#sobre-o-projeto', '_blank');
    ref.opener = null;
  };

  onChange = (field: any, index: any, value: any) => {
    const validation = () => {
      let { coproducer, onChangeRequiredFields } = this.props;
      let newState = { ...this.state };
      newState.validationErrors = run(coproducer, Validations());
      this.setState(newState);
      if (onChangeRequiredFields) {
        onChangeRequiredFields('coProducerRequiredFields', newState.validationErrors ? Object.keys(newState.validationErrors).length : 0);
      }
    };
    if (this.props.onChangeField) {
      this.props.onChangeField(field, index, value);
      validation();
    }
  };

  onSearchCustomerByEmail(email: any) {
    const { currentUser, coproducers, index } = this.props;
    const alreadyHas: boolean = coproducers.filter((c) => c.email === email).length > 1;
    const validation = () => {
      let { coproducer, onChangeRequiredFields } = this.props;
      let newState = { ...this.state };
      newState.validationErrors = run(coproducer, Validations());
      this.setState(newState);
      if (onChangeRequiredFields) {
        onChangeRequiredFields('coProducerRequiredFields', newState.validationErrors ? Object.keys(newState.validationErrors).length : 0);
      }
    };
    this.setState({ existUser: 'validating' });
    (async () => {
      if (!email) {
        this.onChange('email', index, '');
        this.onChange('business_name', index, '');
        validation();
      }
      if (alreadyHas || email === currentUser.email) {
        toast.error(`O e-mail ${email} não pode ser cadastrado novamente pois já faz parte dos parceiros`);
        await this.setState({ isValidEmail: false });
        this.onChange('email', index, '');
        this.onChange('business_name', index, '');
        validation();
      } else {
        await this.props.dispatch(loadCustomerByEmail(email));
        if (this.props.customer && !this.props.customer.length) {
          validation();
        } else {
          await this.props.onSearchSuccess(this.props.index, this.props.customer[0]);
          this.setState({ isValidEmail: true });
          validation();
        }
      }
    })();
  }

  componentDidUpdate(prevProps: any) {
    if (this.props.coproducer !== prevProps.coproducer) {
      let { coproducer, onChangeRequiredFields } = this.props;
      let newState = { ...this.state };
      newState.validationErrors = run(coproducer, Validations());
      this.setState(newState);
      if (onChangeRequiredFields) {
        onChangeRequiredFields('coProducerRequiredFields', newState.validationErrors ? Object.keys(newState.validationErrors).length : 0);
      }
    }
  }

  componentDidMount = () => {
    let { coproducer, onChangeRequiredFields } = this.props;
    let newState = { ...this.state };
    newState.validationErrors = run(coproducer, Validations());
    this.setState(newState);
    if (onChangeRequiredFields) {
      onChangeRequiredFields('coProducerRequiredFields', newState.validationErrors ? Object.keys(newState.validationErrors).length : 0);
    }
  };

  render() {
    const { coproducer, index, disabled, isProducer, onChangeField, classes } = this.props;
    const { permissions } = this.state;
    const commissionType = coproducer.comission_type || 'P';
    const permissionsIcon = permissions ? <ExpandLess /> : <ExpandMore />;
    const permissionsText = permissions ? 'Esconder' : 'Mostrar';
    const isActive = coproducer.active || coproducer.new;
    const isAffiliatesSelectedAndNFNotSelected = coproducer.only_over_affiliates && !coproducer.fiscal_document;
    const isNFSelectedAndAffiliatesNotSelected = !coproducer.only_over_affiliates && coproducer.fiscal_document;

    return (
      <Card style={{ background: '#EEEEEE', border: '1px solid #E0E0E0' }} elevation={0}>
        <CardHeader
          title={
            <Truncate final='...' count={50}>
              {coproducer.business_name}
            </Truncate>
          }
          subheader={
            <Truncate final='...' count={50} style={{ wordBreak: 'break-all' }}>
              {coproducer.email}
            </Truncate>
          }
          avatar={
            <Avatar
              style={{ background: isActive ? '#009358' : '#FFCD06' }}
              src={
                coproducer.customer_id === PROJECT_ELEVAR_ID
                  ? 'https://cdn.eduzzcdn.com/myeduzz/upload/b0/99/b0995f1f0c7e4ad490e6f85f5be5f6c9'
                  : undefined
              }
            >
              <Group />
            </Avatar>
          }
          action={
            <>
              {!coproducer.pending && !coproducer.is_producer && (
                <Tooltip title='Remover parceiro' placement='top'>
                  <IconButton aria-label='remover parceiro'>
                    <Icon className={classes.deleteLink} style={{ fontSize: 24 }} onClick={() => !isProducer && this.props.onRemove(index)}>
                      delete
                    </Icon>
                  </IconButton>
                </Tooltip>
              )}
              {coproducer.is_producer && (
                <Tooltip title='Produtor' placement='top'>
                  <div>
                    <IconButton aria-label='producer' disabled>
                      <Icon className={classes.deleteLink} style={{ fontSize: 24 }}>
                        hail
                      </Icon>
                    </IconButton>
                  </div>
                </Tooltip>
              )}
            </>
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                id='type'
                label='Tipo de comissão'
                select
                fullWidth
                disabled={disabled || commissionType === 'P'}
                value={commissionType || 'P'}
                onChange={(e: any) => this.onChange('comission_type', index, e.target.value)}
                InputProps={{
                  disableUnderline: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value='P'>Porcentagem</MenuItem>
                {commissionType === 'V' && (
                  <MenuItem value='V' disabled>
                    Valor
                  </MenuItem>
                )}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              {commissionType === 'P' && (
                <CustomMaskedInput
                  disabled={disabled || coproducer.is_producer}
                  mask='percent'
                  label='Valor'
                  helperText={this.isValid('comission_value') ? this.errorFor('comission_value') : null}
                  error={this.isValid('comission_value')}
                  startAdornment='%'
                  fullWidth={true}
                  disableUnderline={true}
                  onChange={(value: any) => this.onChange('comission_value', index, value)}
                  value={String(coproducer.comission_value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}

              {commissionType === 'V' && (
                <CustomMaskedInput
                  disabled={disabled}
                  mask='money'
                  label='Valor'
                  helperText={this.isValid('comission_value') ? this.errorFor('comission_value') : null}
                  error={this.isValid('comission_value')}
                  startAdornment='R$'
                  disableUnderline={true}
                  fullWidth={true}
                  onChange={(value: any) => this.onChange('comission_value', index, value)}
                  value={String(coproducer.comission_value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            </Grid>
          </Grid>
        </CardContent>

        <CardActions>
          <Grid container justifyContent='space-between' alignItems='center' spacing={2}>
            <Grid item xs>
              <PartnerStatus cop={coproducer} />
            </Grid>

            {!coproducer.pending && !coproducer.is_producer && (
              <Grid item>
                {coproducer.customer_id === PROJECT_ELEVAR_ID ? (
                  <Button size='small' onClick={this.showMoreElevar}>
                    Saiba mais
                  </Button>
                ) : (
                  <Button size='small' endIcon={permissionsIcon} onClick={this.onTooglePermissions}>
                    {`${permissionsText} permissões`}
                  </Button>
                )}
              </Grid>
            )}

            {coproducer.pending && (
              <Grid item>
                <ApprobationStatus cop={coproducer} />
              </Grid>
            )}
          </Grid>
        </CardActions>

        <Collapse in={permissions} unmountOnExit>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControl>
                  <FormControlLabel
                    label='Afiliados'
                    control={
                      <Switch
                        disabled={disabled || isProducer || isNFSelectedAndAffiliatesNotSelected}
                        color='default'
                        checked={coproducer.only_over_affiliates}
                        onChange={(e: any) => onChangeField('only_over_affiliates', index, e.target.checked)}
                      />
                    }
                  />
                  <FormHelperText>
                    O coprodutor será comissionado somente sobre vendas realizadas através de afiliados.{' '}
                    <a href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807551969-Como-adicionar-um-Co-Produtor-%C3%93rbita-' target='blank'>
                      Saiba mais
                    </a>
                    {isNFSelectedAndAffiliatesNotSelected && (
                      <FormHelperText error={true}>
                        Não é possível ter &quot;Afiliados&quot; e &quot;Emitir NF&quot; marcados ao mesmo tempo.
                      </FormHelperText>
                    )}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl>
                  <FormControlLabel
                    label='Gerir afiliados'
                    control={
                      <Switch
                        disabled={disabled || isProducer}
                        color='default'
                        checked={coproducer.affiliate_manager}
                        onChange={(e: any) => onChangeField('affiliate_manager', index, e.target.checked)}
                      />
                    }
                  />
                  <FormHelperText>
                    O coprodutor consegue: aprovar/ reprovar afiliações, ver relatório de afiliados e conversar com afiliados de todas as variações.
                  </FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl>
                  <FormControlLabel
                    label='Emitir NF'
                    control={
                      <Switch
                        disabled={disabled || isProducer || isAffiliatesSelectedAndNFNotSelected}
                        color='default'
                        checked={coproducer.fiscal_document}
                        onChange={(e: any) => onChangeField('fiscal_document', index, e.target.checked)}
                      />
                    }
                  />
                  <FormHelperText>
                    O coprodutor também será responsável por emitir Nota Fiscal aos clientes.{' '}
                    <a
                      href='https://ajuda.eduzz.com/hc/pt-br/articles/4402651955739-Como-Funciona-a-Central-de-Documentos-Fiscais-%C3%93rbita-'
                      target='blank'
                    >
                      Saiba Mais
                    </a>
                    {isAffiliatesSelectedAndNFNotSelected && (
                      <FormHelperText error={true}>
                        Não é possível ter &quot;Afiliados&quot; e &quot;Emitir NF&quot; marcados ao mesmo tempo.
                      </FormHelperText>
                    )}
                  </FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl>
                  <FormControlLabel
                    label='Reembolsar'
                    control={
                      <Switch
                        disabled={disabled || isProducer}
                        color='default'
                        checked={coproducer.permission_refund}
                        onChange={(e: any) => onChangeField('permission_refund', index, e.target.checked)}
                      />
                    }
                  />
                  <FormHelperText>Quando habilitado, permite o coprodutor reembolsar faturas.</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl>
                  <FormControlLabel
                    label='Ver cliente'
                    control={
                      <Switch
                        disabled={disabled || isProducer}
                        color='default'
                        checked={coproducer.visibility_customer_email}
                        onChange={(e: any) => onChangeField('visibility_customer_email', index, e.target.checked)}
                      />
                    }
                  />
                  <FormHelperText>O coprodutor poderá visualizar os dados dos clientes nos relatórios.</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </CardContent>
        </Collapse>
      </Card>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    customer: state.orbita.Customer.byEmail.data,
    currentUser: state.orbita.User.user,
  };
}

export default styles(connect(mapStateToProps)(PartnerCardPreview)) as any;
